import { permissionKey } from '../../feature/permissions/models/Permission';

export const DEFAULT_OPERATION_IDS = ['view', 'create', 'edit', 'delete'] as const;

export type DefaultOperationId = typeof DEFAULT_OPERATION_IDS[number];

export type OperationId = DefaultOperationId | (string & {});

export const can = (moduleId: string, operationId: OperationId): string => permissionKey(moduleId, operationId);
